export default __webpack_public_path__ + "static/media/Forms.091cbfbe.svg";